export default theme => ({
    popularProducts: {
        position: 'relative',
        marginBottom: 36,
    },
});